import { t } from 'i18next'
import { z } from 'zod'

const cleanHtml = (html: string) => {
  return html
    .replace(/<br\s*\/?>/gi, "")
    .replace(/<[^>]*>/g, "")
    .trim();
};

export const ticketLimitItem = z.object({
  ticketName: z.string().nullable(),
  ticketGuid: z.string().nullable(),
  maxPerUser: z
  .number({
    required_error: "Field is required",
    invalid_type_error: "Must be a number",
  })
  .min(0, "Must be greater than or equal to 0"),
});

export const detailItem = z.object({
  packageId: z  
    .number({ required_error: t('error:field_required') as string })
    .nullable(),

  shopGuid: z
    .string({ required_error: t('error:field_required') as string })
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(100, {
      message: t('error:max_length_100') as string,
    }),
  isDefault: z.boolean().default(false),
  ticketLimits: z.array(ticketLimitItem).default([]),
})

export const workshopEventSchema = z.object({
  eventGuid: z
    .string({ required_error: t('error:field_required') as string })
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(100, {
      message: t('error:max_length_100') as string,
    }),
  categoryId: z.number({ required_error: t('error:field_required') as string }),
  subcategoryIds: z.array(z.number()).optional(),
  isPublished: z.boolean().default(true),
  description: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(20000, {
      message: t('error:max_length_2200') as string,
    }).refine(value => {

      const cleaned = cleanHtml(value);

      return cleaned.length > 0;
    }, {
      message: t('error:field_required') as string,
    }),

  location: z.string().trim().optional(),
  startTime: z.string().trim().optional(),
  endTime: z.string().trim().optional(),

  packageAndShop: z.array(detailItem),
  backgroundId: z.number({
    required_error: t('error:field_required') as string,
  }),
  mobileBackgroundId: z.number({
    required_error: t('error:field_required') as string,
  }),
  mediaId: z.number().optional(),
  mediaMobileId: z.number().optional(),
  metaTitle: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(100, {
      message: t('error:metaTitle_length_error') as string,
    }),
  metaDescription: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(255, {
      message: t('error:metaDescription_length_error') as string,
    }),
  canonical: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(255, {
      message: t('error:canonical_length_error') as string,
    }),
  schemaMarkup: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(255, {
      message: t('error:metaDescription_length_error') as string,
    }),
  metaImage: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    }),
  keywords: z
    .string({
      invalid_type_error: t('error:field_required') as string,
    })
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(255, {
      message: t('error:metaKeyword_length_error') as string,
    }),
})

export type IWorkshopEventSchema = z.infer<typeof workshopEventSchema>

export const defaultValues: IWorkshopEventSchema = {
  eventGuid: undefined as any,
  description: '',
  backgroundId: undefined as any,
  mobileBackgroundId: undefined as any,
  mediaId: undefined as any,
  mediaMobileId: undefined as any,
  location: '',
  startTime: '',
  endTime: '',
  isPublished: true,
  categoryId: undefined as any,
  subcategoryIds: undefined as any,
  packageAndShop: [
    {
      packageId: null,
      shopGuid: undefined as any,
      isDefault: true,
      ticketLimits: [
        {
          ticketName: '',
          ticketGuid: null,
          maxPerUser: 1
        }
      ]
    },
    // {
    //   packageId: undefined as any,
    //   shopGuid: undefined as any,
    //   isDefault: false,
    //   ticketLimits: [
    //     {
    //       ticketName: '',
    //       ticketGuid: null,
    //       maxPerUser: null
    //     }
    //   ]
    // },
  ],
  metaTitle: '',
  metaDescription: '',
  canonical: '',
  schemaMarkup: 'Schema markup Live Life Clean',
  metaImage: '',
  keywords: '',
}
